import styled from "styled-components";

export const Container = styled.div`
height : 860px;
`;
